var _a, _b, _c, _d, _e;
import { __decorate, __metadata, __param } from "tslib";
import { CopyCustomFieldService } from '@/domains/custom-fields/services/copy-custom-field-service.interface';
import { I18nService } from '@/services/i18n-service';
import { injectable, inject } from 'inversify';
import { GroupOrUserInputServiceReader } from './group-or-user-input-reader.interface';
import { Message } from '@patsnap/tahiti-core/common/message';
import { RavenService } from '@cores/modules/raven-module/raven-service';
let CopyCustomFieldCommandContribution = class CopyCustomFieldCommandContribution {
    constructor(_i18nService, _copyCustomFieldService, _groupOrUserInputServiceReader, _message, _ravenService) {
        this._i18nService = _i18nService;
        this._copyCustomFieldService = _copyCustomFieldService;
        this._groupOrUserInputServiceReader = _groupOrUserInputServiceReader;
        this._message = _message;
        this._ravenService = _ravenService;
    }
    registerCommands(commands) {
        commands.registerCommand({
            id: 'custom-field.copy',
            icon: 'SolidCopy',
            label: this._i18nService.t('customField.actions.copyTo'),
        }, {
            execute: (context) => {
                return this._execute(context);
            },
        });
    }
    async _execute(context) {
        this._ravenService.track('Share Custom Field');
        const [result, closeDialog] = await this._groupOrUserInputServiceReader.read();
        await this._copyCustomField(context, result);
        closeDialog();
        this._message.success({
            message: this._i18nService.t('shareField.success'),
            showClose: true,
        });
    }
    async _copyCustomField(context, groupOrUserInput) {
        const copyOptions = {
            fields: context.fields,
            groupIds: groupOrUserInput.groupIds,
            userIds: groupOrUserInput.userIds,
        };
        return this._copyCustomFieldService.copy(copyOptions);
    }
};
CopyCustomFieldCommandContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(CopyCustomFieldService)),
    __param(2, inject(GroupOrUserInputServiceReader)),
    __param(3, inject(Message)),
    __param(4, inject(RavenService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof CopyCustomFieldService !== "undefined" && CopyCustomFieldService) === "function" ? _b : Object, typeof (_c = typeof GroupOrUserInputServiceReader !== "undefined" && GroupOrUserInputServiceReader) === "function" ? _c : Object, typeof (_d = typeof Message !== "undefined" && Message) === "function" ? _d : Object, typeof (_e = typeof RavenService !== "undefined" && RavenService) === "function" ? _e : Object])
], CopyCustomFieldCommandContribution);
export { CopyCustomFieldCommandContribution };
